import React, { useRef } from 'react';

import { localize } from 'common/utils';
import { useMenuModuleContext } from 'modules/menu/context';
import { useSharedMenuLink } from 'modules/menu/hooks/useSharedMenuLink';
import { MenuEditorRoot } from 'modules/shared-menu/components/MenuEditorRoot';
import { OnboardingStepsProvider } from 'modules/shared-menu/contexts/OnboardingStepsContext';
import { SharedMenu } from 'modules/shared-menu/types';

import { RestrictedVenueLevelHeader } from './components/RestrictedVenueLevelHeader';
import { SingleVenueHeader } from './components/SingleVenueHeader';
import { Root } from '../../components/CommonStyles';
import MenuEditorDnDContext from '../SharedMenuEditorPage/components/dnd/MenuEditorDnDContext';
import { MenuMainElementRefContext } from '../SharedMenuEditorPage/context/MenuMainElementRefContext';
import { WoltSpecialsContextProvider } from '../SharedMenuEditorPage/context/WoltSpecialsContext';

type VenueLevelMenuEditorPageProps = {
  selection: SharedMenu;
};

export const VenueLevelMenuEditorPage = ({ selection }: VenueLevelMenuEditorPageProps) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const mainElementRef = useRef<HTMLDivElement>(null);
  const { venue } = useMenuModuleContext();
  const { sharedMenuLink } = useSharedMenuLink();
  const isSharedVenue = !!sharedMenuLink?.selection_is_shared;

  return (
    <OnboardingStepsProvider>
      <WoltSpecialsContextProvider>
        <MenuMainElementRefContext.Provider value={mainElementRef}>
          <Root ref={rootRef}>
            <MenuEditorDnDContext>
              {isSharedVenue ? (
                <RestrictedVenueLevelHeader selectionName={localize(selection.name, selection.primary_language)} />
              ) : (
                <SingleVenueHeader />
              )}
              <MenuEditorRoot woltcomUrl={venue.public_url} />
            </MenuEditorDnDContext>
          </Root>
        </MenuMainElementRefContext.Provider>
      </WoltSpecialsContextProvider>
    </OnboardingStepsProvider>
  );
};
